// src/components/sections/Stats.jsx
import React from 'react';
import { useTranslation } from '../../i18n';

const Stats = () => {
  const { t } = useTranslation();

  const stats = [
    { value: '2015', key: 'stat_foundation', icon: '📅' },
    { value: '99 ans', key: 'stat_duration', icon: '⏳' },
    { value: "N'Djamena", key: 'stat_headquarters', icon: '📍' },
  ];

  return (
    <div className="relative">
      <div className="tricolor-flag-thin" />
      
      <div className="grid grid-cols-1 md:grid-cols-3 bg-ofd-blue relative">
        {stats.map((stat, index) => (
          <div
            key={index}
            className={`px-5 py-10 text-center ${
              index < stats.length - 1 ? 'border-b md:border-b-0 md:border-r border-white/10' : ''
            } transition-all duration-300 hover:bg-ofd-blue/80`}
          >
            <div className="text-3xl mb-2">{stat.icon}</div>
            <strong className="block font-playfair text-4xl md:text-5xl font-black text-ofd-yellow leading-none">
              {stat.value}
            </strong>
            <span className="block text-xs font-medium text-white/70 tracking-[0.5px] uppercase mt-2">
              {t(stat.key)}
            </span>
          </div>
        ))}
      </div>
      
      <div className="tricolor-flag-thin" />
    </div>
  );
};

export default Stats;